<template>
  <Modal appear @close="close">
    <template slot="content">
      <div class="p-config-management-form">
        <div class="p-config-management-form__header">
          <h3 class="p-config-management-form__title">
            ユーザーにサイトのアクセス権を追加する
          </h3>
        </div>
        <div class="p-config-management-form__content">
          <div class="c-fieldset c-fieldset--wrap">
            <p class="c-fieldset__header">
              <span class="c-fieldset__title">
                サイト限定ユーザー
              </span>
              <span class="c-required">必須</span>
            </p>
            <div class="c-fieldset__content c-alertPos">
              <UserCandidates
                v-model="params.users"
                input="checkbox"
                :items="users"
                :isLoading="isLoading"
              />
            </div>
          </div>
          <div class="c-fieldset c-fieldset--wrap">
            <p class="c-fieldset__header">
              <span class="c-fieldset__title">閲覧可能なサイト</span>
              <span class="c-required">必須</span>
            </p>
            <div class="c-fieldset__content c-alertPos">
              <ProjectCandidates
                v-model="params.projectIds"
                input="checkbox"
                :items="projects"
                :isLoading="isLoading"
              />
            </div>
          </div>
        </div>
        <div class="p-config-management-form__footer">
          <div class="c-alertPos">
            <Button
              variant="main"
              size="w230"
              fsize="f16"
              :disabled="isDisabled"
              :class="{ 'is-loading': isProcessing }"
              @click="submit"
            >
              追加する
            </Button>
            <Alert v-if="request.error" variant="center">
              {{ request.error }}
            </Alert>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Modal from '@/components/Modal';
import ProjectCandidates from '@/components/config/ProjectCandidates';
import UserCandidates from '@/components/config/UserCandidates';
import apiOrganizations from '@/api/organizations';
import utils from '@/utils';
import Validation from '@/validation';

export default {
  components: {
    Alert,
    Button,
    Modal,
    ProjectCandidates,
    UserCandidates
  },
  data() {
    return {
      error: {
        projectIds: '',
        users: ''
      },
      params: {
        projectIds: [],
        users: []
      },
      request: {
        error: ''
      },
      isEdited: {
        projectIds: false,
        users: false
      },
      isError: false,
      isLoading: true,
      isProcessing: false
    };
  },
  computed: {
    accesses() {
      return this.$store.state.organizations.projects.reduce((acc, cur) => {
        acc[cur.projectId] = cur.users.map(user => user.userId);
        return acc;
      }, {});
    },
    organization() {
      return this.$store.getters['view/organization'];
    },
    projects() {
      return this.$store.state.user.data.projects;
    },
    users() {
      return this.$store.state.organizations.users.filter(
        user => !user.isAuthority
      );
    },
    isDisabled() {
      return this.isError || this.isProcessing;
    }
  },
  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    },
    params: {
      handler() {
        // 何か入力したらサーバーからのエラーメッセージを消す
        this.request.error = '';
      },
      deep: true
    },
    'params.projectIds': {
      handler(value, oldValue) {
        this.error.projectIds = new Validation().select().test(value);

        if (typeof oldValue !== 'undefined') {
          this.isEdited.projectIds = true;
        }
      },
      immediate: true
    },
    'params.users': {
      handler(value, oldValue) {
        this.error.users = new Validation().select().test(value);

        if (typeof oldValue !== 'undefined') {
          this.isEdited.users = true;
        }
      },
      immediate: true
    }
  },
  created() {
    Promise.all([
      this.$store.dispatch('organizations/getUsers'),
      this.$store.dispatch('user/getProjects')
    ]).finally(() => {
      this.isLoading = false;
    });
  },
  methods: {
    checkError() {
      this.isError = utils.checkError(this.error);
    },
    close() {
      this.$emit('close');
    },
    async submit() {
      if (this.isDisabled) {
        return;
      }
      this.isProcessing = true;

      // サイトのアクセス権のデータを最新にする
      await Promise.all([
        this.$store.dispatch('organizations/getProjects'),
        this.$store.dispatch('user/getProjects')
      ]);

      const requests = [];
      this.params.users.forEach(user => {
        this.params.projectIds.forEach(projectId => {
          // アクセス権がない場合のみリクエストに追加する
          if (
            this.projects.some(project => project.id === projectId) &&
            (!this.accesses[projectId] ||
              !this.accesses[projectId].includes(user.userId))
          ) {
            const request = apiOrganizations.users.permissions.project.post(
              this.auth.idToken,
              this.organization.organizationId,
              user.userId,
              projectId
            );
            requests.push(request);
          }
        });
      });

      Promise.all(requests)
        .then(response => {
          this.isProcessing = false;
          this.$emit('add');
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.request.error = error.response.data.errors[0].userMessage;
          }
          this.isProcessing = false;
        });
    }
  }
};
</script>
